import {Box, Icon, Show} from 'platform/foundation';

import {HTMLAttributes} from 'react';

import {DragHandle} from '@dms/features/dnd';
import i18n from '@dms/i18n';

import {DRAG_HANDLE_GUTTER_WIDTH} from '../constants/DRAG_HANDLE_GUTTER_WIDTH';

interface DragHandleSlotProps {
  handleProps?: HTMLAttributes<HTMLDivElement>;
}

/**
 * Leading card-header slot for a sortable template card. Its width is reserved even without
 * `handleProps`, so the header does not shift while the handle is temporarily hidden.
 */
export function DragHandleSlot(props: DragHandleSlotProps) {
  return (
    <Box width={DRAG_HANDLE_GUTTER_WIDTH}>
      <Show when={props.handleProps}>
        <DragHandle {...props.handleProps} aria-label={i18n.t('general.actions.reorder')}>
          <Icon value="action/drag_indicator" color="text.secondary" />
        </DragHandle>
      </Show>
    </Box>
  );
}
